import styled from 'styled-components';
import { IconStyled } from '@ch/common/components/icon';
import Tooltip from 'react-tooltip';

export const QuizTooltipWrap = styled.span`
  vertical-align: middle;
  display: inline-flex;
  ${IconStyled} {
    cursor: pointer;
  }
`;

export const QuizTooltipStyled = styled(Tooltip)`
  width: 300px;
`;
